export const STYLE_HIDE_BACKGROUND = {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 1000,
    pointerEvents: 'auto',
    WebkitTapHighlightColor: 'rgba(0,0,0,0)',
    transition: 'opacity .4s cubic-bezier(.25,.8,.25,1)',
    opacity: 1,
    backgroundColor: '#00000080',
    display: 'none'
};
